import React, {useState} from 'react'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { CgClose } from 'react-icons/cg'
import SendEmailModal from '../../../components/Modal/SendEmailModal'
import { TfiEmail } from 'react-icons/tfi'
import { GoDownload } from 'react-icons/go'
import SaveIcon from "../SaveIcon"
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; 
import ImageWithFallback from "../ImageWithFallback"
import { API_END_POINT, END_POINT } from '../../../utils/constant'
import axios from 'axios'
import Notification from '../../../components/Notification'
import { PrintResume2 } from '../../../ui/Resume'

const FindTalentCard = ({item, user, ...props}) => {
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)
    const [showSendEmailModal, setShowSendEmailModal] = useState(false)
    const {showScroll, setshowScroll} = useOutletContext()
    const [loading, setLoading] = useState(false)
    const [isSaved, setIsSaved] = useState(false)
    const [showNotif, setShowNotif] = useState({
        show: false,
        message:"Une erreur est survenue",
        variant: "danger"
      })

    const handleSaveToFavorite = (item) => {
        // const formDataToSend = new FormData();
        // formDataToSend.append("offer_id", item.id);
        // formDataToSend.append("user_id", user.id);
        // console.log("canidate added to favorite", formDataToSend)
         axios.post(API_END_POINT+"/candidate/addToFavorite", {
            user_id: 1, // A MODIFIER par user.id
            candidate_id: 2, // A MODIFIER par 
        })
        .then((response) =>{ 
            console.log(response?.data)
            setShowNotif({...showNotif, variant: "success", message:response?.data?.message, show: true})})
        .catch((error) =>{ 
            console.log(error)
            setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})})
      };

    const animateSkeleton =()=>{
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
      }, 2000);
    }
  return (
    <>
    <div  className='bg-white rounded-lg overflow-hidden border p-4 transition-all ease-in hover:border-gray-400 cursor-pointer' {...props}>
    <div className="flex justify-between  ">
        <div className=' flex flex-row gap-3  items-center w-[80%]'>
            {/* <img src={img4} alt="logo"  className='w-56 h-56 object-cover rounded-sm'/> */}
            <ImageWithFallback src={END_POINT+"/storage"+item?.photo} className=" w-56 h-56 object-cover rounded-sm" defaultType="candidate"/>
            <div className='w-full flex flex-col justify-between h-full'>
                <p className='text-level-1 flex-col justify-between text-start mb-4'>
                    <div className='text-lg font-semibold'>{ item?.candidate_profile?.name || "Nom de l'utilisateur" }</div>
                    <span className='text-sm'>{item?.candidate_profile?.current_job}</span>
                    <p className='text-start text-sm text-primary-text'>{item?.candidate_profile?.bio || "Aucune bio disponible pour ce candidat"}</p>
                </p>

                    <div className="grid grid-cols-3 text-start w-full mb-4">
                        <div>
                            <p className='text-sm text-primary-text'>Genre</p>
                            <p>{item?.candidate_profile?.gender || "Non mentionné"}</p>
                        </div>
                        <div>
                        <p className="text-sm text-primary-text">Travaille à</p>
                        <p>{item?.candidate_profile?.work_at || "Non spécifié"}</p>
                        </div>
                        <div>
                            <p className='text-sm text-primary-text'>Disponibilité</p>
                            <p>{item?.is_avalaible ? "Non" : "Oui"}</p>
                        </div>
                    </div>

                    <div className="flex gap-2">                      
                        <div className="flex flex-wrap gap-2 ">
                            {item?.candidate_profile?.resume_skills?.map((skill, index)=>{
                                if(index < 5)return(
                                    <div key={index} className="bg-neutral-50 text-neutral-500 text-sm px-2 py-1 border rounded-full">{skill?.name}</div>
                                )
                            })}

                            {
                                item?.candidate_profile?.resume_skills?.length > 5 && (
                                <div 
                                className="bg-neutral-50 text-primary-black text-sm px-2 py-1 border rounded-full">
                                {item?.candidate_profile?.resume_skills?.length - 5} et plus
                                </div>
                            )}
                            
                        </div>
                    </div>
                    
            </div>
        </div> 

        <div className="flex items-end flex-col justify-between ">
            <SaveIcon isSaved={isSaved} setIsSaved={setIsSaved} action={()=>handleSaveToFavorite(item)} /> 
            <button  
            onClick={()=>{
                setShowModal(true)
                animateSkeleton()
                setshowScroll(false)
            }
            }
            className='bg-[#4dff4d] whitespace-nowrap border-none rounded-sm text-[#145926] font-semibold text-sm px-4 py-2 flex gap-2 items-center'>Voir Le Profil </button>
        </div>  
        
    </div>

</div>

<AnimatePresence>
    {
        showModal && (
    
        <motion.div 
        initial={{ opacity: 0  }}
        animate={{opacity: 1}}
        exit={{ opacity: 0 }}
        className="fixed ease-in duration-200 z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm backdrop-filter">
        <motion.div
        // Animation pour l'apparition
        initial={{ opacity: 0, right: "-100%", y: 20 }}
        animate={{ opacity: 1, right: 0, y: 0 }}
        exit={{ opacity: 0, right: "-100%", y: 20 }}
        transition={{ type: "spring", stiffness: 130, damping: 20 }}
        className="fixed px-6 overflow-y-auto bg-white w-full lg:w-2/3 xl:w-1/2 min-h-full lg:rounded-s-2xl drop-shadow-lg max-h-screen"
        >
            <div className="flex justify-end py-4">
                <button 
                onClick={()=>{
                    setShowModal(false)
                    setshowScroll(true)
                    }}>
                    <CgClose/>
                </button>
            </div>

            <div className="flex justify-between items-center mb-4">
                   <div className="flex gap-4 items-center">
          {loading ?
            <Skeleton circle={true} height={50} width={50} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
            <ImageWithFallback src={item?.image} className=" w-10 h-10 rounded-full object-cover " defaultType="user"/>
          }
   
       
          <div className='flex flex-col justify-between  items-start '>
          {loading ?
            <Skeleton width={100} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
          <h1 className='text-lg font-semibold text-start'>{item?.candidate_profile?.name }</h1>
          }

          {loading ?
            <Skeleton width={150} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
          <p className='text-sm text-start'>{item?.candidate_profile?.current_job }</p>
          } 
            
          </div>
        </div>
                <div className="flex gap-x-2">
                                      <PrintResume2 data={item?.candidate_profile} />
                      
                    <button 
                    onClick={()=>setShowSendEmailModal(true)}
                    className="p-2 w-10 flex justify-center items-center border rounded-md"><TfiEmail/></button>
                </div>
            </div>
                    {
                        loading ?
                        <div className="flex flex-wrap gap-2">
                            <Skeleton  height={25} width={200} className='rounded-xl' highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                            <Skeleton  height={25} width={200} className='rounded-xl' highlightColor='#fbfbfb' baseColor='#e9e9e9'/>                    
                        </div>
                        : 
                        <div className="flex flex-wrap gap-2">
                            <div className="py-1 text-sm px-2 text-primary-text rounded-full bg-gray-50">{item?.candidate_profile?.phone }</div>
                            <div className="py-1 text-sm px-2 text-primary-text rounded-full bg-gray-50">{item?.candidate_profile?.address }</div>
                        </div>
                    }

            <div className="border rounded-md grid grid-cols-2 md:grid-cols-3 gap-4 text-start mt-4 py-4 px-6 mb-4">
        <div>
          <p className='text-sm text-primary-text'>Disponibilité</p>
          <p className='font-semibold text-sm'>{item?.candidate_profile?.is_avalaible ? "Oui" : "Non"}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Diplôme</p>
          <p className='font-semibold text-sm'>{item?.candidate_profile?.highest_diploma}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Année d'obtention</p>
          <p className='font-semibold text-sm'>{item?.candidate_profile?.phone}</p>
        </div>
      </div>

            <div className="space-y-6">
                <div className="flex-col text-start">
                    {
                        loading ?
                        <Skeleton count={2} height={10} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                        :
                        <p className="text-primary-text">
                            {item?.candidate_profile?.bio ||
                            "Aucune bio disponible pour ce candidat"}
                        </p>
                    }
                   
                </div>
                { 
                    item?.candidate_profile?.resume_skills && 
                    <div className="flex-col text-start">
                        <h4 className=' font-semibold  mb-2'>Compétences</h4>
                        <div className=" flex gap-2">
                        { 
                                item?.candidate_profile?.resume_skills?.map((skill, index)=>{
                                    return (
                                        <div className="py-2 px-6 text-primary-text bg-gray-50">{skill?.name}</div>
                                    )
                                }
                                )
                            }
                            
                        </div>
                    </div>
                }

                {
                    loading ?
                    <>
                        <div className="flex-col items-start flex mb-4">
                        <Skeleton width={200} height={15} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                        </div>
                        <Skeleton count={2} height={10} highlightColor='#fbfbfb' baseColor='#e9e9e9' className='w-full'/>
                    </>
                    :
                    <>
                        {/* Expérience */}
            { 
                item?.candidate_profile?.experiences && 
                <div className="flex-col text-start">
                    <h4 className=' font-semibold  mb-4'>Expérience</h4>
                    {
                        item?.candidate_profile?.experiences?.map((experience, index)=>{
                            return(
                                <div className="flex gap-4 items-start w-full  mb-6 py-4 border-b">
                                    <div className="rounded-full bg-gray-50 border border-gray-300 flex items-center justify-center size-12 min-w-12">
                                        <svg fill="#6b7280" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" 
                                        width="30px" height="30px" viewBox="0 0 64 64" enable-background="new 0 0 64 64"
                                        className='size-6 '  >
                                        <g>
                                        <path d="M62,16H42.727C42.064,13.082,39.791,8,32,8s-10.064,5.082-10.727,8H2c-1.104,0-2,0.896-2,2v36c0,1.104,0.896,2,2,2h60
                                            c1.104,0,2-0.896,2-2V18C64,16.896,63.104,16,62,16z M32,12c4.335,0,5.98,2.244,6.608,4H25.388C26.018,14.253,27.669,12,32,12z
                                            M60,20v8H4v-8H60z M29,32h6v2h-6V32z M4,52V32h21v4c0,1.104,0.896,2,2,2h10c1.104,0,2-0.896,2-2v-4h21v20H4z"/>
                                        </g>
                                        </svg>
                                    </div>
                                {/* <img src={bookmaker} alt="entreprise" className='w-12 h-12 rounded-full bg-gray-50 border' /> */}
                                <div className='w-full'>
                                    <div className="flex justify-between items-start mb-2">                            
                                        <div className="text-start flex-col">
                                            <h6 className='text-base font-semibold'>{experience?.title}</h6>
                                            <div className="inline-block gap-2 text-sm ">
                                            {experience?.company} . {experience?.address}
                                            </div>
                                        </div>
                                        <p className='text-sm'>{experience?.start_month} {experience?.start_year} - {experience?.start_month} {experience?.end_year}</p>
                                    </div>
                                    <p className=' text-primary-text'>{experience?.description}</p>
                                </div>
                                </div>   
                            )
                        })
                    }
                
                </div>
            }

                {/* Education */}
                {
                    item?.candidate_profile?.educations && 
                    <div className="flex-col text-start">
                        <h4 className='font-semibold mb-6 text-lg'>Education</h4>
                        {
                        item?.candidate_profile?.educations?.map((education, index) => {
                            return (
                            <div key={index} className="flex gap-4 items-start w-full mb-6 py-4 border-b">
                                <div className="rounded-full bg-gray-50 border border-gray-300 flex items-center justify-center size-12 min-w-12">
                                <svg width="24px" height="24px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                                className='size-7 ' 
                                >
                                <path d="M7.5 4.5L11.5 6.5V14.5H3.5V6.5L7.5 4.5ZM7.5 4.5V0M0 14.5H15M1.5 14.5V8.5H3.5M13.5 14.5V8.5H11.5M6.5 14.5V11.5H8.5V14.5M7.5 0.5H10.5V2.5H7.5M7.5 9.5C6.94772 9.5 6.5 9.05228 6.5 8.5C6.5 7.94772 6.94772 7.5 7.5 7.5C8.05228 7.5 8.5 7.94772 8.5 8.5C8.5 9.05228 8.05228 9.5 7.5 9.5Z" stroke="#6b7280"/>
                                </svg>
                                </div>

                                <div className='w-full'>
                                <div className="flex justify-between items-start mb-3">                            
                                    <div className="text-start">
                                    <h6 className="text- font-semibold">{education?.school || 'Etablissement Inconnu'}</h6>
                                    <div className="text-sm text-gray-600">{education?.address || 'Etablissement Inconnu'}</div>
                                    </div>
                                    <p className='text-sm text-gray-500'>{education?.start_year} - {education?.end_year}</p>
                                </div>
                                <p className='text-primary-text text-sm'>
                                    {education?.description || 'No description available for this education.'}
                                </p>
                                </div>
                                
                            </div>   
                            )
                        })
                        }
                    </div>
                    }
                {/* Languages */}
                { 
                    item?.candidate_profile?.languages && 
                    <div className="flex-col text-start mb-6">
                        <h4 className=' font-semibold  mb-4'>Langues</h4>
                        <div className=" flex items-center gap-2 flex-wrap">
                        {
                            item?.candidate_profile?.languages?.map((language, index)=>{
                                return(
                                    <div className="py-2 pl-4 pr-3.5 text-primary-text flex gap-4 items-center border rounded-sm">
                                        <div className="w-8 h-8 bg-primary-black flex items-center justify-center text-white rounded-full uppercase">
                                        {language?.title?.slice(0, 2).toUpperCase()}
                                        </div>
                                        <div className="flex flex-col gap-y-1 text-primary-black">
                                            <p className='text-start font-semibold'>{language?.title}</p>
                                            <p>{language?.merit}</p>
                                        </div>
                                    </div>
                                )}
                            )
                        }
                        </div>
                    </div>
                }
                <br />
            </>
                }
                </div>
            </motion.div>
        </motion.div>
)}
</AnimatePresence>

<SendEmailModal isOpen={showSendEmailModal} onClose={setShowSendEmailModal}/>
<Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />
</>
  )
}

export default FindTalentCard